import { ReviewerStatus } from "@/Utils/Plan/PlanSubmisionsTypes";
import { appstr } from "@coreapp/utils/appstr";
import { Button, Flex } from "@theorgchartdev/storybook";

type ActivityApproveRejectButtonsProps = {
  reviewerStatus: ReviewerStatus;
  onApprove: () => void;
  onReject: () => void;
  dataTestIdPrefix: string;
};

const ActivityApproveRejectButtons = ({
  reviewerStatus,
  onApprove,
  onReject,
  dataTestIdPrefix
}: ActivityApproveRejectButtonsProps) => {
  const canApprove = reviewerStatus !== ReviewerStatus.Approved;
  const canReject = reviewerStatus !== ReviewerStatus.Rejected;

  return (
    <Flex gap={"16px"}>
      <Button
        color="success"
        modifier="quaternary"
        onClick={onApprove}
        disabled={!canApprove}
        iconProps={{ name: "circle-check" }}
        className="oc-fill-width"
        dataTestId={dataTestIdPrefix ? `${dataTestIdPrefix}-approve-btn` : undefined}
        tooltipProps={{
          message: !canApprove ? appstr("You have already approved this plan") : undefined,
          popoverProps: {
            referenceProps: {
              className: "oc-flex-1"
            }
          }
        }}
      >
        {appstr("Approve")}
      </Button>
      <Button
        color="error"
        modifier="quaternary"
        onClick={onReject}
        disabled={!canReject}
        iconProps={{ name: "circle-xmark" }}
        className="oc-fill-width"
        dataTestId={dataTestIdPrefix ? `${dataTestIdPrefix}-reject-btn` : undefined}
        tooltipProps={{
          message: !canReject ? appstr("You have already rejected this plan") : undefined,
          popoverProps: {
            referenceProps: {
              className: "oc-flex-1"
            }
          }
        }}
      >
        {appstr("Reject")}
      </Button>
    </Flex>
  );
};

export default ActivityApproveRejectButtons;
